const groupPrefix = 'discounts'
const groupPrefixCoupons = 'coupons'

export const apiDiscountCodes = {
	fetchDiscountCode: async (codeID: number) => {
		const { data } = await apiCommon<IDiscountCode>(`${groupPrefix}/${codeID}`, { method: 'GET' })
		return DiscountCode(data)
	},

	fetchAllDiscountCodes: async (page = 1, perPage = 10) => {
		const { data, meta } = await apiCommon<IDiscountCode[]>(`${groupPrefix}?page=${page}&per_page=${perPage}`, {
			method: 'GET',
		})
		if (!data) return { data: [], meta }
		const response = data.map((product) => {
			return DiscountCode(product)
		})
		return { data: response, meta }
	},

	updateDiscountCode: async (codeID: string, parameters: IDiscountCodeForm) => {
		const { data } = await apiCommon<IDiscountCode>(`${groupPrefix}/${codeID}`, { method: 'PUT', body: discountCodeToJSON(parameters) })
		return DiscountCode(data)
	},

	createDiscountCode: async (parameters: IDiscountCodeForm) => {
		const { data } = await apiCommon<IDiscountCode>(`${groupPrefix}`, {
			method: 'POST',
			body: discountCodeToJSON(parameters),
		})
		return DiscountCode(data)
	},

	deleteDiscountCode: async (codeID: string) => {
		const data = await apiCommon<string>(`${groupPrefix}/${codeID}`, { method: 'DELETE' })
		return data
	},

	checkDiscountCode: async (couponCode: string, bookingUUID: string, lang: string = 'en', strict: boolean = false) => {
		if (lang !== 'pl' && lang !== 'en') lang = 'en'
		const { data } = await apiCommon<ICouponCode>(
			`${groupPrefixCoupons}/${couponCode}`,
			{ method: 'GET', query: { booking_uuid: bookingUUID, strict: strict ? 1 : 0 } },
			lang,
		)
		return CouponCode(data)
	},

	checkCodeUsages: async (couponID: string, page = 1) => {
		const { data, meta } = await apiCommon<ICouponCodeUsage[]>('coupon-usages', {
			method: 'GET',
			query: { 'filter[coupon_id]': couponID, page },
		})
		if (!data) return { data: [], meta }
		const response = data.map((product) => {
			return DiscountCodeUsage(product)
		})
		return { data: response, meta }
	},
}
